module.exports = __webpack_public_path__ + "static/media/munch9.3f351430.wav";